import { Box, Text as RooText } from 'roo-ui/components';
import { display } from 'styled-system';
import styled from '@emotion/styled';
import Icon from 'components/Icon';
import HorizontalRule from 'components/Layout/HorizontalRule';

const Text = styled(RooText)`
  ${display};
`;

export const Label = ({ children }) => (
  <Text display={['none', 'block']} as="div" color="greys.steel" mb={0} lineHeight="tight" pb="1">
    {children}
  </Text>
);
Label.displayName = 'Label';

export const MainText = ({ children, fontSize = ['base', 'lg'] }) => (
  <Text as="div" fontSize={fontSize} lineHeight="normal" mb={0}>
    {children}
  </Text>
);
MainText.displayName = 'MainText';

export const SubText = ({ children }) => (
  <Text display={['none', 'block']} as="div" lineHeight="normal" fontSize="base" mb={0}>
    {children}
  </Text>
);
SubText.displayName = 'SubText';

export const MobileIcon = styled((props) => (
  <Icon name="place" size={20} color="greys.steel" bg="greys.alto" p={1} display={['block', 'none']} {...props} />
))`
  position: absolute;
  top: 5px;
  left: 0;
`;

MobileIcon.displayName = 'MobileIcon';

export const HorizontalRuleDesktop = () => <HorizontalRule display={['none', 'block']} blockg="greys.alto" />;
HorizontalRuleDesktop.displayName = 'HorizontalRuleDesktop';

export const Wrapper = (props) => {
  return (
    <Box position="relative" pb={[5, 0]} borderBottom={[1, 0]} borderColor="greys.alto" mb={[5, 0]}>
      {props.children}
    </Box>
  );
};
Wrapper.displayName = 'Wrapper';
